// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__X-eyf","priceMobile":"Heading_priceMobile__Ajse7","address":"Heading_address__r7sqR","verified":"Heading_verified__I00+D"};